/* eslint-disable jira/filename-case */

import '@jira/platform__utils-app-base/src/index.tsx';
import './error-tracking.tsx';
import '@jira/platform__observability-browser-metrics/src/initBrowserMetrics3.tsx';

// Need to disable this because this affects how files are bundled together
// oxlint-disable-next-line no-unused-vars
const lazyImports = () => {
	// oxlint-disable-next-line typescript/no-require-imports
	require('@jira/platform__observability-analytics-providers/src/AnalyticsProviders.tsx');
	// oxlint-disable-next-line typescript/no-require-imports
	require('@jira/platform__observability-engagement');
	// oxlint-disable-next-line typescript/no-require-imports
	require('@jira/platform__utils-date-fns');
};

// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
global.__SPA__ = false;
